import React, {createContext, useState} from 'react';
import {injectIntl} from "react-intl";
import {getAPIGatewayPostRequest, getNodeId} from "../util/Util";
import {getAPIGatewayDataFromParent} from "../handler/ParentDataHandler";
import {ENDPOINT_GET_MQTT_CONNECTION_DETAILS, MQTT_CONNECTION_DETAILS_EXPIRY_TIMEOUT} from "../util/Constants";

export const MQTTPermissionsContext = createContext();

const MQTTPermissionsContextProvider = (props) => {
  const [config, setConfig] = useState({});

  const refreshConnectionDetails = async () => {
    const currentTime = new Date()
    if (config.expirationTime !== undefined) {
      const expiredTime = new Date(config.expirationTime)
      if (expiredTime - currentTime < MQTT_CONNECTION_DETAILS_EXPIRY_TIMEOUT) {
        return await fetchConnectionDetails()
      } else {
        return config
      }
    } else {
      return await fetchConnectionDetails()
    }
  }

  const fetchConnectionDetails = async () => {
    const request = {
      nodeId : getNodeId()
    }
    const args = getAPIGatewayPostRequest(request, ENDPOINT_GET_MQTT_CONNECTION_DETAILS);
    const response = await getAPIGatewayDataFromParent(args);
    if (response.status !== 200) {
      return config;
    } else {
      setConfig(response.data)
      return response.data;
    }
  }

  const value = {
    refreshConnectionDetails
  };

  return <MQTTPermissionsContext.Provider value={value}>{props.children}</MQTTPermissionsContext.Provider>
}

export default injectIntl(MQTTPermissionsContextProvider);



// WEBPACK FOOTER //
// ./src/components/permissions/MQTTPermissionsContext.js